function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export var convertLimitStringToNumber = function(input) {
    var regex = /^(\d+\.?\d*)([KMGT]?)$/;
    var match = regex.exec(input.toUpperCase());
    if (!match) return 0;
    var numberPart = parseFloat(match[1]);
    var magnitudePart = match[2];
    switch(magnitudePart){
        case "K":
            return numberPart * 1000;
        case "M":
            return numberPart * 1000000;
        case "G":
            return numberPart * 1000000000;
        case "T":
            return numberPart * 1000000000000;
        default:
            return numberPart;
    }
};
export var convertLimitToString = function(input) {
    if (input >= 1000000000000) {
        return (input / 1000000000000).toFixed(2) + "T";
    } else if (input >= 1000000000) {
        return (input / 1000000000).toFixed(2) + "G";
    } else if (input >= 1000000) {
        return (input / 1000000).toFixed(2) + "M";
    } else if (input >= 1000) {
        return (input / 1000).toFixed(2) + "K";
    } else {
        return String(input);
    }
};
export var TIER_HEADERS;
(function(TIER_HEADERS) {
    TIER_HEADERS["accountUsage"] = "X-AccountUsage-Limit";
    TIER_HEADERS["assetsUsage"] = "X-AssetsUsage-Limit";
    TIER_HEADERS["deploymentDebugInstances"] = "X-DeploymentDebugInstances-Limit";
    TIER_HEADERS["deploymentDomains"] = "X-DeploymentDomains-Limit";
    TIER_HEADERS["deploymentInstances"] = "X-DeploymentInstances-Limit";
    TIER_HEADERS["marketplaceWorkspaces"] = "X-MarketplaceWorkspaces-Limit";
    TIER_HEADERS["numberQueues"] = "X-NumberQueues-Limit";
    TIER_HEADERS["queueInflight"] = "X-QueueInflight-Limit";
    TIER_HEADERS["queueMessageSizeBytes"] = "X-QueueMessageSizeBytes-Limit";
    TIER_HEADERS["queueRate"] = "X-QueueRate-Limit";
    TIER_HEADERS["queuedElements"] = "X-QueuedElements-Limit";
    TIER_HEADERS["redisSearchIndexes"] = "X-RedisSearchIndexes-Limit";
    TIER_HEADERS["rps"] = "RPS";
})(TIER_HEADERS || (TIER_HEADERS = {}));
var _obj;
export var tierLimitNames = (_obj = {}, _define_property(_obj, "RPS", {
    icon: "filter-solid",
    name: "Throughput load",
    units: "rps"
}), _define_property(_obj, "X-AccountUsage-Limit", {
    icon: "pie-chart-solid",
    name: "Account usage",
    units: "B"
}), _define_property(_obj, "X-AssetsUsage-Limit", {
    icon: "packet-solid",
    name: "Assets usage",
    units: "B"
}), _define_property(_obj, "X-DeploymentInstances-Limit", {
    icon: "ai-solid",
    name: "Deployment instances",
    units: ""
}), _define_property(_obj, "X-DeploymentDebugInstances-Limit", {
    icon: "ai-line",
    name: "Deployment debug instances",
    units: ""
}), _define_property(_obj, "X-DeploymentDomains-Limit", {
    icon: "globe-solid",
    name: "Deployment domains",
    units: ""
}), _define_property(_obj, "X-MarketplaceWorkspaces-Limit", {
    icon: "code-solid",
    name: "Templates",
    units: ""
}), _define_property(_obj, "X-NumberQueues-Limit", {
    icon: "reorder-vertical-solid",
    name: "Queues number",
    units: ""
}), _define_property(_obj, "X-QueueInflight-Limit", {
    icon: "bring-to-front-solid",
    name: "Max queues inflight",
    units: ""
}), _define_property(_obj, "X-QueueMessageSizeBytes-Limit", {
    icon: "file-add-solid",
    name: "Max message size",
    units: "B"
}), _define_property(_obj, "X-QueueRate-Limit", {
    icon: "stream-solid",
    name: "Max queue rate",
    units: ""
}), _define_property(_obj, "X-QueuedElements-Limit", {
    icon: "density-high-solid",
    name: "Queued elements",
    units: ""
}), _define_property(_obj, "X-RedisSearchIndexes-Limit", {
    icon: "books-solid",
    name: "Redis search indexes",
    units: ""
}), _obj);

//# sourceMappingURL=tiers.js.map